import { render } from "./IconHamburger.vue?vue&type=template&id=91055a06"
import script from "./IconHamburger.vue?vue&type=script&lang=js"
export * from "./IconHamburger.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__